import { Drawer } from "antd";
import { DrawerSizes } from "../../../../common/constants";
import { Client } from "../../types";
import { ClientDetailView } from "../dataview/ClientDetailView";
import { ClientTypeTagWithName } from "../tags/ClientTypeTagWithName";

interface Props {
  client?: Client;
  onClose: () => void;
}

export const ClientDetailDrawer = ({ client, onClose }: Props) => {
  return (
    <Drawer
      title={client && <ClientTypeTagWithName client={client} />}
      size={DrawerSizes.MEDIUM}
      open={!!client}
      closable
      onClose={onClose}
    >
      {client && <ClientDetailView client={client} isNarrowView />}
    </Drawer>
  );
};
